<div class="ui container">
    <app-header-component [state]="state" [protocol]="protocol">
    </app-header-component>
    <div id="DATA-PDF">
        <div style='overflow-x: auto;' style="margin-bottom: 2em;">
            <table class="ui celled structured table unstackable">
                <thead>
                    <tr>
                        <th colspan="2" class="center aligned">DATOS PRELIMINARES</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class='label'>Denominación: <span class='negrita'>{{ ut || "-" }}</span></td>
                        <td class='label'> OT: <span class='negrita'>{{ ot || "-" }}</span></td>
                    </tr>
                    <tr>
                        <td class='label'> Fecha:
                            <span class='negrita'>
                                <ng-container *ngIf="when; else noDate">
                                    {{ when | date: 'dd/MM/yyyy' }}
                                </ng-container>
                                <ng-template #noDate>-</ng-template>
                            </span>
                        </td>
                        <td class='label'>Ejecutante:
                            <span class='negrita'>{{ performer || "-" }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="ui divider no-pdf-flex"></div>

        <div *ngFor="let item of actividades;index as i" class="container-protocol   no-pdf">
            <div class="ui grid " style="margin-top: 0.5em;">

                <div class="sixteen wide column">
                    <h4 class="title-style">{{item.title}}</h4>

                    <div *ngFor="let instruccion of item.items;index as indexSeccion" class="ui styled accordion "
                        style="margin-top: 0.5em;">
                        <div [id]="'panel'+item.title+indexSeccion" class="title "
                            (click)="activePanel(item.title+indexSeccion)">
                            <i class="dropdown icon"></i>
                            {{instruccion.name}}
                            <i *ngIf="instruccion.warning" class=" exclamation triangle icon pointer"
                                [style.color]="'red'">
                            </i>
                            <i *ngIf="instruccion.out" class=" exclamation circle icon pointer" [style.color]="'red'">
                            </i>
                        </div>
                        <div [id]="'content'+item.title+indexSeccion" class="content ">
                            <app-table-results *ngIf="item" [nro]="ot" [data]="[instruccion]"></app-table-results>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div *ngFor="let item of actividades; index as i" class=" si-pdf">
            <div>
                <div class="sixteen wide column" style="margin-top: 0.5em;">
                    <h4 class="title-style">{{ item.title }}</h4>

                    <div *ngFor="let instruccion of item.items; index as indexSeccion" style="margin-top: 0.5em;">
                        <p>
                            <strong>{{ instruccion.name }}</strong>
                            <span *ngIf="instruccion.warning" style="color: red;">⚠️</span>
                            <span *ngIf="instruccion.out" style="color: red;">❗</span>
                        </p>

                        <app-table-results [nro]="ot" [data]="[instruccion]">
                        </app-table-results>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div class="ui grid">
        <div class="extra content">
            <button style="margin-top: 3em;" class="ui right labeled icon button button-filter primary"
                (click)="goHome()">
                <i class="home
                          icon"></i>
                Volver
            </button>
        </div>
    </div>
</div>